<template>
    <el-dialog title="详情" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true"
        width="512px">
        <div class="user-info">
            <el-avatar :size="50" :src="tableData.user_info.head_img"></el-avatar>
            <span class="username">{{ tableData.user_info.name }}</span>
        </div>
        <div class="user-detail">
            <p>用户ID: {{ tableData.user_info.id }}</p>
            <p>申请时间: {{ tableData.created_at }}</p>
            <h4>用户地址:</h4>
            <p>收货人: {{ tableData.user_address_log.user_name }}</p>
            <p>手机号码: {{ tableData.user_address_log.user_phone }}</p>
            <p>地址: {{ tableData.user_address_log.address_details }}</p>
            <p>邮编: {{ tableData.user_address_log.postal_code }}</p>
        </div>
        <div class="logistic-info" v-if="tableData.logistics_log">
            <h4>物流信息:</h4>
            <p>物流公司: {{ tableData.logistics_log.logistics_name }}</p>
            <p>物流编码: {{ tableData.logistics_log.logistics_number }}</p>
        </div>
        <div class="option-box">
            <el-button @click="trunOff">返回</el-button>
        </div>


    </el-dialog>
</template>

<script>
export default {
    data: () => ({}),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 模式
        type: {
            default: 'add',
            type: String
        },
        // 编辑的数据
        tableData: null | Object
    },
    methods: {
        trunOff() {
            this.showModal = false
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.user-info {
    display: flex;
    align-items: center;

    .username {
        margin-left: 10px;
        font-size: 1rem;
    }
}
</style>